import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
  .set('GetListConversaciones', new Immutable.List([]))
  .set('GetListConversacionesPaginacion', new Immutable.Map({}))
  .set('GetMensajesForEjec', new Immutable.List([]))
  .set('GetListMensajesPaginacion', new Immutable.Map({}))
  .set('GetContactDataDonataria', new Immutable.Map({}))
  .set('GetContactDataEjecutivo',new Immutable.Map({}))
  .set('SearchParameter', new Immutable.Map({}))
  .set('GetNewConversationsEjec',new Immutable.Map({}))
  .set('GetNewConversationsDon',new Immutable.Map({}))


/*Types*/
export const ACTION_GET_CONVERSACIONES_LIST = "ACTION_GET_CONVERSACIONES_LIST"
export const ACTION_GET_CONVERSACIONES_PAGINACION = "ACTION_GET_CONVERSACIONES_PAGINACION"
export const ACTION_SET_INFO_DONATARIA_MENSAJES = 'ACTION_SET_INFO_DONATARIA_MENSAJES'
export const ACTION_GET_LIST_MENSAJES_FOR_EJEC = "ACTION_GET_LIST_MENSAJES_FOR_EJEC"
export const ACTION_GET_MENSAJES_PAGINACION = "ACTION_GET_MENSAJES_PAGINACION"
export const ACTION_GET_CONTACT_DATA = "ACTION_GET_CONTACT_DATA"
export const ACTION_GET_CONTACT_DATA_EJECUTIVO = "ACTION_GET_CONTACT_DATA_EJECUTIVO"
export const ACTION_GET_NEW_CONVERSATIONS_EJEC = "ACTION_GET_NEW_CONVERSATIONS_EJEC"
export const ACTION_GET_NEW_CONVERSATIONS_DON = "ACTION_GET_NEW_CONVERSATIONS_DON"


export default (state = initialState, action) => {

  switch (action.type) {
    case ACTION_GET_CONVERSACIONES_LIST:
      return state.set('GetListConversaciones', new Immutable.List(action.Obj))
    case ACTION_GET_CONVERSACIONES_PAGINACION:
      return state.set('GetListConversacionesPaginacion', new Immutable.Map(action.Obj))
    case ACTION_SET_INFO_DONATARIA_MENSAJES:
      return state.set('GetInfoDonatariaMensajes', new Immutable.Map(action.Obj))
    case ACTION_GET_LIST_MENSAJES_FOR_EJEC:
      return state.set('GetMensajesForEjec', new Immutable.List(action.Obj))
    case ACTION_GET_MENSAJES_PAGINACION:
      return state.set('GetListMensajesPaginacion', new Immutable.Map(action.Obj))
    case ACTION_GET_CONTACT_DATA:
      return state.set('GetContactDataDonataria', new Immutable.Map(action.Obj))
    case ACTION_GET_CONTACT_DATA_EJECUTIVO:
      return state.set('GetContactDataEjecutivo', new Immutable.Map(action.Obj))
    case ACTION_GET_NEW_CONVERSATIONS_EJEC:
      return state.set('GetNewConversationsEjec', new Immutable.Map(action.Obj))
    case ACTION_GET_NEW_CONVERSATIONS_DON:
      return state.set('GetNewConversationsDon', new Immutable.Map(action.Obj))
    default:
      return state
  }

}

/*Action Creators*/

export const getListadoConversaciones = (form) => {
  return (dispatch) => {
    dispatch(isLoading(true))
    return new ClientHttpRequest({
      service: 'api/getListConversaciones',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_GET_CONVERSACIONES_LIST, Obj: response.data})
      // dispatch({ type: ACTION_GET_CONVERSACIONES_PAGINACION, Obj: response.data.paginacion })
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const getInfoDonataria = (idDonataria) => {
  return (dispatch) => {
    dispatch(isLoading(true))
    return new ClientHttpRequest({
      service: 'api/getInfoDonataria',
      method: 'POST',
      data: { idDonataria },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({type: ACTION_GET_CONTACT_DATA, Obj: response.data})
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}


export const getListMensajesForEjec = (form) => {
  return (dispatch) => {
    dispatch(isLoading(true))
    return new ClientHttpRequest({
      service: 'api/getListMensajesForEjec',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_GET_CONTACT_DATA_EJECUTIVO, Obj: response.data })
      dispatch({ type: ACTION_GET_LIST_MENSAJES_FOR_EJEC, Obj: response.data.mensajes})
      dispatch({ type: ACTION_GET_MENSAJES_PAGINACION, Obj: response.data.paginacion })
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}


export const saveMensajesEjecutivo = (form) => {
  return (dispatch) => {

    let temp = {
      idDonataria: form.idDonataria,
      ejecutivo: form.ejecutivo,
      aviso: form.aviso,
      usuario: sessionStorage.uid
    }

    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/saveMensajesEjecutivo',
      method: "POST",
      data: {...temp},
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then((response) => {
      dispatch(isLoading(false))
      return response.data
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const sendMensajesEjecutivo = (form) => {
  return (dispatch) => {
    let temp = {
      idDonataria: form.idDonataria,
      nombreDonataria: form.nombreDonataria,
      ejecutivo: {
        idUsuario: form.ejecutivo
      },
      aviso: form.aviso
    }
    
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/sendMensajesEjecutivo',
      method: "POST",
      data: {...temp},
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then((response) => {
      dispatch(isLoading(false))
      return response.data
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const confirmNewConversationsEjec = () => {
  let temp={
    ejecutivo:sessionStorage.uid
  }
  return (dispatch) => {
    dispatch(isLoading(true))
    return new ClientHttpRequest({
      service: 'api/confirmNewConversationsEjec',
      method: 'POST',
      data: { ...temp },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_GET_NEW_CONVERSATIONS_EJEC, Obj: response.data})

    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const confirmNewConversationsDon = (idDonataria) => {

  return (dispatch) => {
    dispatch(isLoading(true))
    return new ClientHttpRequest({
      service: 'api/confirmNewConversationsDon',
      method: 'POST',
      data: { idDonataria },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_GET_NEW_CONVERSATIONS_DON, Obj: response.data})
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}

export const setInfoDonataria = (form) => {
	return (dispatch) => {
		dispatch({type: ACTION_SET_INFO_DONATARIA_MENSAJES, Obj: form})
		return Promise.resolve()
	}
}

export const clearListadoConversaciones= () => {
	return (dispatch) => {
    dispatch({ type: ACTION_GET_CONVERSACIONES_LIST, Obj: []})
    dispatch({ type: ACTION_GET_CONVERSACIONES_PAGINACION, Obj: {} })
	}
}

export const clearListadoMensajes= () => {
	return (dispatch) => {
    dispatch({ type: ACTION_GET_LIST_MENSAJES_FOR_EJEC, Obj: []})
    dispatch({ type: ACTION_GET_MENSAJES_PAGINACION, Obj: {} })
	}
}

export const clearContactData= () => {
	return (dispatch) => {
    dispatch({ type: ACTION_GET_CONTACT_DATA, Obj: {} })
    dispatch({ type: ACTION_GET_CONTACT_DATA_EJECUTIVO, Obj: {} })
	}
}

export const clearDataMSGDon= () => {
	return (dispatch) => {
    dispatch({ type: ACTION_GET_NEW_CONVERSATIONS_DON, Obj: {} })
	}
}
export const clearDataMSGEjec= () => {
	return (dispatch) => {
    dispatch({ type: ACTION_GET_NEW_CONVERSATIONS_EJEC, Obj: {} })
	}
}









// WEBPACK FOOTER //
// ./src/modules/Mensajes/Mensajes.js